export default __webpack_public_path__ + "static/media/applicants1.0155605c.jpg";